import {useCallback, useRef} from 'react';

interface UseDebounceFnOptions {
  delay?: number;
}

export const useDebounceFn = (fn: (...args: any[]) => any, {delay = 300}: UseDebounceFnOptions = {}) => {
  const timeoutId = useRef(-1);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  return useCallback((...args: any[]) => {
    window.clearTimeout(timeoutId.current);
    timeoutId.current = window.setTimeout(() => {
      fnRef.current(...args);
    }, delay);
  }, []);
};
